var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticClass: "item",
      attrs: { effect: "dark", content: _vm.value, placement: "top" },
    },
    [_c("span", [_vm._v(_vm._s(_vm.showVal))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }